import { Cart } from './Cart';

export class ProductForm extends HTMLElement {
	constructor() {
		super();
		this.cart = new Cart();
	}

	connectedCallback() {
		const form = this.querySelector('form');
		if (form) {
			form.addEventListener('submit', this.handleSubmit.bind(this));
			console.log('ProductForm initialized');
		} else {
			console.warn('No <form> found inside <product-form>');
		}
	}

	async handleSubmit(event) {
		event.preventDefault();

		const formData = new FormData(event.target);
		const id = formData.get('id');
		const quantity = parseInt(formData.get('quantity'), 10) || 1;

		if (!id) {
			console.error('Product ID is required');
			return;
		}

		try {
			const result = await this.cart.addItem(id, quantity);
			console.log('Added to cart:', result);
		} catch (error) {
			console.error('Error adding to cart:', error);
		}
	}
}
